const selectArrayToArray = (_data,key) =>{    
    let _value = [];
    for (let d = 0; d < _data.length; d++) {
        _value.push(_data[d][key]);
    }
    return _value;
};
export default selectArrayToArray;